import object from 'common/helpers/primitives/object'
import { RecommendationsPageState } from 'pages/recommendations/types'


export const initialState: RecommendationsPageState = {
  isRetaking: false,
  isFetching: true,
  isFetched: false,
  isEmpty: false,
  quiz: null,
  history: null,
  selections: null,
  rated: null,
}

export const update = (state, payload) => {
  const newState = object.mergeDeep(state, payload) as RecommendationsPageState

  newState.isEmpty = [ 'quiz', 'history', 'selections', 'rated' ].every((result) => {
    const source = newState[result]

    return !source || source.isEmpty
  })

  return newState
}

export const setFetchingStatuses = (state, payload) => (
  object.mergeDeep(state, payload)
)

// export const updateQuiz = (state, payload) => (
//   object.updateIn(state, [ 'quiz' ], (prevState) => ({ ...prevState, payload  }))
// )
//
// export const updateHistory = (state, payload) => (
//   object.updateIn(state, [ 'history' ], (prevState) => ({ ...prevState, payload  }))
// )
//
// export const updateSelections = (state, payload) => (
//   object.updateIn(state, [ 'selections' ], (prevState) => ({ ...prevState, payload  }))
// )


export const clear = () => initialState
